import { apiService } from './apiService';
import { API_ENDPOINTS, ERROR_MESSAGES } from '../constants/apiConstants';

export const systemPromptService = {
  // Create system prompt
  createSystemPrompt: async (data) => {
    try {
      const response = await apiService.post(API_ENDPOINTS.SYSTEM_PROMPT, {
        category: data.category,
        prompt: data.prompt
      });

      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'System prompt created successfully'
      };
    } catch (error) {
      console.error('Create system prompt error:', error);
      
      let errorMessage = ERROR_MESSAGES.SERVER_ERROR;
      
      if (error.response) {
        // Check for 'detail' field (FastAPI style) or 'message' field
        const apiError = error.response.data?.detail || error.response.data?.message;
        
        switch (error.response.status) {
          case 400:
            errorMessage = apiError || ERROR_MESSAGES.VALIDATION_ERROR;
            break;
          case 401:
            errorMessage = ERROR_MESSAGES.UNAUTHORIZED;
            break;
          case 404:
            errorMessage = 'System prompt endpoint not found';
            break;
          case 500:
            errorMessage = ERROR_MESSAGES.SERVER_ERROR;
            break;
          default:
            errorMessage = apiError || ERROR_MESSAGES.SERVER_ERROR;
        }
      } else if (error.request) {
        errorMessage = ERROR_MESSAGES.NETWORK_ERROR;
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  },

  // Get system prompts (if needed later)
  getSystemPrompts: async (params = {}) => {
    try {
      const response = await apiService.get(API_ENDPOINTS.SYSTEM_PROMPT, { params });

      return {
        success: true,
        data: response.data,
        message: 'System prompts fetched successfully'
      };
    } catch (error) {
      console.error('Get system prompts error:', error);
      
      return {
        success: false,
        message: ERROR_MESSAGES.SERVER_ERROR,
        error: error.response?.data || error.message
      };
    }
  },

  // Update system prompt
  updateSystemPrompt: async (id, data) => {
    try {
      const payload = {};
      if (typeof data.prompt !== 'undefined') payload.prompt = data.prompt;
      if (typeof data.category !== 'undefined') payload.category = data.category;

      const response = await apiService.patch(`${API_ENDPOINTS.SYSTEM_PROMPT}${id}`, payload);

      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'System prompt updated successfully'
      };
    } catch (error) {
      console.error('Update system prompt error:', error);
      
      let errorMessage = ERROR_MESSAGES.SERVER_ERROR;
      
      if (error.response) {
        // Check for 'detail' field (FastAPI style) or 'message' field
        const apiError = error.response.data?.detail || error.response.data?.message;
        
        switch (error.response.status) {
          case 400:
            errorMessage = apiError || ERROR_MESSAGES.VALIDATION_ERROR;
            break;
          case 401:
            errorMessage = ERROR_MESSAGES.UNAUTHORIZED;
            break;
          case 404:
            errorMessage = 'System prompt not found';
            break;
          case 500:
            errorMessage = ERROR_MESSAGES.SERVER_ERROR;
            break;
          default:
            errorMessage = apiError || ERROR_MESSAGES.SERVER_ERROR;
        }
      } else if (error.request) {
        errorMessage = ERROR_MESSAGES.NETWORK_ERROR;
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  }
};